import { ButtonTriggerEvent } from '../../../common/components';

export class ShowPromptModalActions {
    confirm: (event: ButtonTriggerEvent) => void;
    cancel?: () => void;
}

export class PromptModalData {
    constructor(title: string, message: string | null, messages: string[] = [], isShowCheckbox: boolean = true) {
        this.title = title;
        this.message = message;
        this.messages = messages;
        this.isShowCheckbox = isShowCheckbox;
    }

    title: string;
    message: string | null;
    messages: string[];
    isShowCheckbox: boolean;
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/show.prompt.modal/show.prompt.modal.provider.ts